export const TITLE = 'Access Code';
export const PLACEHOLDER = 'secret-quiz';
export const CAPTION = 'Leaving this blank would mean that students can freely enter the quiz.';
